import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Globe, Lock, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-[#F5F7FB] relative" data-id="element-143" data-mp="1j9756u290rzz">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-144" data-mp="1nakc77h2v18h">
        <div className="text-center mb-10" data-id="element-145" data-mp="1na0sbl7va2rt">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-[#081632]" data-id="element-146" data-mp="1s9dfk72nhbux">
            Your complete <span className="text-[#D89B16]" data-id="element-147" data-mp="1x8zuqm21h26d">Judo Coach Ready</span> package
          </h2>
          <p className="text-[#081632]/75 text-sm md:text-base" data-id="element-148" data-mp="227t4q4i4ab1s">
            The complete coaching system — ready for your next session.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#081632] border-2 border-[#D89B16] rounded-3xl p-1 relative shadow-xl shadow-[#1E4ED8]/15" data-id="element-149" data-mp="2wjq1pow5w3m">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#D89B16] text-[#081632] font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-150" data-mp="1cqlobii169pp">
            <Sparkles size={14} data-id="element-151" data-mp="25fslad1u6r8u" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-152" data-mp="25d6e4eiuydr5">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#081632] mb-3" data-id="element-153" data-mp="20h8v20g7mtao">
              Judo Coach Ready — Complete{' '}
              <span className="text-[#D89B16]" data-id="element-154" data-mp="1rg19miyslmy0">6-in-1 Visual Coaching System</span>
            </h3>
            <p className="text-base text-slate-700 mb-6" data-id="element-155" data-mp="k1xzxe1zj47x">You receive:</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-[#F5F7FB] border border-[#D89B16]/40 rounded-xl p-4" data-id="element-156" data-mp="jzuxtvnk5kmu">
              {packageIncludes.map(item => <li key={item.label} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-157" data-mp="hib45vd7yns7">
                  {item.kind === 'bonus' ? <Gift size={16} className="text-[#1E4ED8] shrink-0 mt-0.5" data-id="element-158" data-mp="7ju5ec81h4vl" /> : <Check size={16} className="text-[#D89B16] shrink-0 mt-0.5" data-id="element-159" data-mp="ci5gsrdzfnfx" />}
                  <span data-id="element-160" data-mp="3uw4mqocxocky">{item.label}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-161" data-mp="3hqkkwzhcnxn">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-162" data-mp="3is4lqyh4kri">
                <span className="text-2xl md:text-3xl text-[#081632]/75" data-id="element-163" data-mp="3kzjgjzp6gvfj">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-[#081632]" data-id="element-164" data-mp="3px1opnvdf6mh">$27 USD</span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-165" data-mp="3bybuqh3uln2c">
              🟡 GET JUDO COACH READY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500 mb-4" data-id="element-166" data-mp="2sca0l8chgyit">
              <span className="flex items-center gap-1.5" data-id="element-167" data-mp="36cazii96tvvn">
                <Lock size={12} className="text-[#1E4ED8]" data-id="element-168" data-mp="369oscjq7lidy" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-169" data-mp="31bdm0iz4hq0h">
                <Zap size={12} className="text-[#1E4ED8]" data-id="element-170" data-mp="3g960d7sxo8d3" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-171" data-mp="3bbnwhvtrwjby">
                <Check size={12} className="text-[#1E4ED8]" data-id="element-172" data-mp="3b91nrsv5bxs5" /> Complete Digital PDF Bundle
              </span>
            </div>

            <div className="bg-[#F5F7FB] border border-[#D89B16]/40 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-173" data-mp="3l05vq8memidh">
              <Globe className="text-[#081632] shrink-0 mt-0.5" size={14} data-id="element-174" data-mp="2vkmvkj3okkz" />
              <p className="text-[11px] text-slate-500 leading-snug" data-id="element-175" data-mp="3u2f3wru79znp">
                🌍 Payment availability and currency conversion may vary according to your checkout
                provider and country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}